module.exports = __webpack_public_path__ + "img/actv1.ba50ce4c.jpeg";